module.exports = __webpack_public_path__ + "Activities-b15fba824a78197436f096b7eb75bf32.svg";